const STORAGE_KEY = "comfortkino-buy-draft"

export type BuyDraft = {
    sessionId: number
    selectedSeatIds: number[]
}

export function loadBuyDraft(): BuyDraft | null {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY)
        if (!raw) return null
        return JSON.parse(raw) as BuyDraft
    } catch {
        return null
    }
}

export function saveBuyDraft(draft: BuyDraft): void {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
    } catch {
        /* ignore quota errors */
    }
}

export function clearBuyDraft(): void {
    try {
        sessionStorage.removeItem(STORAGE_KEY)
    } catch {
        /* ignore */
    }
}
